var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86304 14.9632C9.86304 13.3876 11.1403 12.1104 12.7159 12.1104H33.6367C35.2123 12.1104 36.4896 13.3876 36.4896 14.9632C36.4896 16.5388 35.2123 17.816 33.6367 17.816H12.7159C11.1403 17.816 9.86304 16.5388 9.86304 14.9632Z",
    fill: "#6FBE45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2316 37.3091L11.8394 20.6018C12.1255 20.646 12.4186 20.6689 12.7171 20.6689H33.638C33.9362 20.6689 34.229 20.646 34.5148 20.602L33.1226 37.3091C32.8761 40.2663 30.4041 42.5409 27.4366 42.5409H18.9176C15.9501 42.5409 13.4781 40.2663 13.2316 37.3091ZM25.5537 31.1298C25.5537 29.8168 24.4893 28.7524 23.1763 28.7524C21.8633 28.7524 20.7989 29.8168 20.7989 31.1298C20.7989 32.4428 21.8633 33.5071 23.1763 33.5071C24.4893 33.5071 25.5537 32.4428 25.5537 31.1298ZM23.1763 25.8996C26.0649 25.8996 28.4065 28.2412 28.4065 31.1298C28.4065 34.0183 26.0649 36.36 23.1763 36.36C20.2877 36.36 17.9461 34.0183 17.9461 31.1298C17.9461 28.2412 20.2877 25.8996 23.1763 25.8996Z",
    fill: "#6FBE45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.471 4.50317C15.3703 4.50317 13.6672 6.20619 13.6672 8.30696V9.2582H32.6862V8.30697C32.6862 6.20619 30.9832 4.50317 28.8824 4.50317H17.471Z",
    fill: "#6FBE45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/coffee.09460f26ec49c5ba5482b423b870e1c4.svg";
export { ForwardRef as ReactComponent };